import React from 'react';
import ReactDOM from 'react-dom';
import { Admin, Resource } from 'react-admin';

import 'bootstrap/dist/css/bootstrap.min.css';
import './components/Buttons/ButtonsStyle.css';

import './stylization/App.css';

// Providers
import { MuiThemeProvider } from '@material-ui/core/styles';
import authClient from './providers/authClient';
import restClientAutoo from './providers/restClientAutoo';
import addUploadFeature from './providers/addUploadFeature';
import addUploadFeature2 from './providers/addUploadFeature2';
import {
  apiUrl, ROLE_ADMIN, ROLE_CALLCENTER_ADMIN, ROLE_CALLCENTER_MANAGER, ROLE_QCD_ADMIN
} from './config';

import { ROLE_COMPANY_ADMIN, ROLE_COMPANY_MANAGER } from './config';

import Login from './pages/Login';
import theme from './stylization/SecretarTheme';

import CustomerList from './pages/callcenter/customer/List';
import CustomerListCompany from './pages/company/customer/List';
import CustomerCallcenterList from './pages/admin/customer/List';

import PaymentList from './pages/admin/payments/List';
import PaymentListCallcenterAdmin from './pages/callcenter/payments/List';
import CallcenterList from './pages/admin/callcenter/List';
import StatisticsCompany from './pages/admin/statistics_company/List';

import Users from './pages/admin/users/List';
import UsersCallcenterAdmin from './pages/callcenter/users/List';

import Company from './pages/admin/company/List';
import CompanyCallcenterAdmin from './pages/callcenter/company/List';

import StatisticsCallcenterAdmin from './pages/admin/statistics_callcenter/List';
import StatisticsCallcenter from './pages/callcenter/statistics_callcenter/List';
import StatisticsSubject from './pages/admin/statistics_subject/List';

import Layout from './stylization/SecretarLayout';

import messages from './i18n/index';

import { hasAccess } from './common';

import scReducer from './redux/reducers';
import scSaga from './redux/sagas';
import RequestLogList from './pages/admin/requestlog/List';
import ClientsListAdmin from './pages/admin/clients/List';
import ClientListCompany from './pages/company/clients/List';
import ClientListQcd from './pages/qcd/clients/List';


const restClient = restClientAutoo(apiUrl);
const uploadCapableClient = addUploadFeature2(addUploadFeature(restClient));

const ROLES_PAYMENT = [ROLE_ADMIN];
const ROLES_CLIENT = [ROLE_ADMIN, ROLE_COMPANY_ADMIN, ROLE_COMPANY_MANAGER];

function returnComponent3(role, componentAdmin, componentCallcenterAdmin) {
  switch (role) {
    case ROLE_ADMIN:
      return componentAdmin;
    case ROLE_CALLCENTER_ADMIN:
      return componentCallcenterAdmin;
    case ROLE_CALLCENTER_MANAGER:
    case ROLE_COMPANY_ADMIN:
    case ROLE_COMPANY_MANAGER:
    case ROLE_QCD_ADMIN:
      return null;
    default:
      return null;
  }
}

function returnComponent2(role, componentAdmin, componentCallcenter, componentCompany, componentQcd = null) {
  switch (role) {
    case ROLE_ADMIN:
      return componentAdmin;
    case ROLE_CALLCENTER_ADMIN:
    case ROLE_CALLCENTER_MANAGER:
      return componentCallcenter;
    case ROLE_COMPANY_ADMIN:
    case ROLE_COMPANY_MANAGER:
      return componentCompany;
    case ROLE_QCD_ADMIN:
      return componentQcd;
    default:
      return null;
  }
}

const i18nProvider = locale => messages[locale];

const App = () => (
  <Admin
    title="Секретарь | ЛК"
    dataProvider={uploadCapableClient}
    authProvider={authClient}
    loginPage={Login}
    appLayout={Layout}
    theme={theme}
    locale="rus"
    i18nProvider={i18nProvider}
    customReducers={{ sc: scReducer }}
    customSagas={[scSaga]}
  >
    {role => {
      const ClientsResource = (
        <Resource
          name="clients"
          list={returnComponent2(role, ClientsListAdmin, null, ClientListCompany, ClientListQcd)}
        />
      );
      let resources = [
        <Resource
          name="customer"
          list={returnComponent2(role, CustomerCallcenterList, CustomerList, CustomerListCompany)}
        />,
        <Resource
          name="payment"
          list={returnComponent3(role, PaymentList, PaymentListCallcenterAdmin)}
        />,
        <Resource
          name="statistics-callcenter"
          list={returnComponent2(role, StatisticsCallcenterAdmin, StatisticsCallcenter, null)}
        />,
        <Resource
          name="statistics-company"
          list={hasAccess(role, ROLES_PAYMENT) ? StatisticsCompany : null}
        />,
        <Resource
          name="statistics-subject"
          list={hasAccess(role, ROLES_PAYMENT) ? StatisticsSubject : null}
        />,
        <Resource
          name="users"
          list={returnComponent3(role, Users, UsersCallcenterAdmin)}
        />,
        <Resource
          name="company"
          list={returnComponent3(role, Company, CompanyCallcenterAdmin)}
        />,
        <Resource
          name="callcenter"
          list={hasAccess(role, ROLES_PAYMENT) ? CallcenterList : null}
        />,
        <Resource
          name="requestlog"
          list={hasAccess(role, ROLES_PAYMENT) ? RequestLogList : null}
        />
      ];
      if (role === 'qcd_admin') {
        resources = [ClientsResource].concat(resources);
      } else {
        resources = resources.concat([ClientsResource]);
      }
      return resources;
    }}
  </Admin>
);

ReactDOM.render(<MuiThemeProvider theme={theme}><App /></MuiThemeProvider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js